export default __webpack_public_path__ + "static/media/IO.91ef2ed4.svg";